<template>
  <main class="font page-main">
    <section class="font-visual" data-style="show">
      <video
        muted
        loop
        autoplay
        playsinline
        poster="~@/static/image/font/pc/visual.jpg"
      >
        <source src="~@/static/video/fonts_visual.mp4" type="video/mp4">
        Sorry, your browser doesn't support embedded videos.
      </video>
      <div class="font-visual-inner">
        <h3>{{ $t('menuFonts') }}</h3>
        <div class="font-visual-description">
          <html-view :value="$t('fonts.description')" />
        </div>
        <p><a :href="require('@/static/font/BM-font-package.zip')" download class="btn font-download">{{ $t('fonts.downloadAll') }}</a></p>
      </div>
    </section>

    <section class="font-preview" data-style="default">
      <div class="font-preview-title">{{ selectFont.shortName }}</div>
      <div class="font-preview-value" :class="{'dohyeon': selectFont.family === 'BM DoHyeon'}" :style="`font-family: '${selectFont.family}', sans-serif`">
        <div class="value" contenteditable @input="onPreviewText" />
        <div v-if="previewText.length <= 0" class="placeholder">{{ $t('fonts.placeholder') }}</div>
      </div>
      <div class="font-preview-list">
        <template v-for="(item, key) in list">
          <button
            v-if="item.shortName"
            :key="key"
            type="button"
            class="btn"
            :class="{
              'btn-fill': selectFontIndex === key
            }"
            @click="selectFontIndex = key"
          >
            {{ item.shortName }}
          </button>
        </template>
      </div>
    </section>

    <section class="font-mobile" data-style="default">
      <html-view :value="$t('fonts.mobileCannot')" tag="h4" />
      <html-view :value="$t('fonts.description')" class="font-mobile-description" />
      <p class="font-mobile-notice">{{ $t('fonts.license.m') }}</p>
      <share
        :list="['kakaotalk', 'facebook', 'twitter', 'link']"
        :share-image="shareImagePath"
        :title="$route.params.locale === 'en' ? 'Baedal Minjok Fonts' : '배달의민족 글꼴'"
      />
      <!--      <share :list="['kakaotalk', 'facebook', 'twitter', 'link']" url="" :title="" />-->
    </section>

    <section class="font-list" data-style="default">
      <div v-for="(item, key) in fontList" :key="key" class="font-box animation up">
        <images :v="item.images" />
        <p class="font-title">
          <html-view :value="$t(item.name)" tag="span" />
          <sup>{{ item.date }}</sup>
        </p>
        <html-view :value="item.description " tag="p" class="font-description" />
        <nav class="font-download">
          <a v-for="(down, value) in item.download" :key="value" :href="down">
            {{ value.toUpperCase() }} {{ $t('download') }}
            <icon-download class="icon icon-download" />
          </a>
        </nav>
      </div>

      <div class="font-next">
        <div class="font-next-description">
          <html-view :value="$t('fonts.nextFont')" tag="p" />
        </div>
        <share
          :list="['kakaotalk', 'facebook', 'twitter', 'link']"
          :share-image="shareImagePath"
          :title="$route.params.locale === 'en' ? 'Baedal Minjok Fonts' : '배달의민족 글꼴'"
        />
      </div>
    </section>

    <section class="font-go-license" data-style="default">
      <p class="pc">{{ $t('fonts.license.pc') }}</p>
      <p class="m">{{ $t('fonts.license.m') }}</p>
      <!--      <button type="button" @click="onToggleLicense">-->
      <!--        <span>라이센스 보러가기</span>-->
      <!--        <icon-blank />-->
      <!--      </button>-->
      <router-link :to="{name: 'FontsLicense', params: {locale: $route.params.locale}}">
        <span>{{ $t('fonts.license.link') }}</span>
        <icon-blank />
      </router-link>
    </section>

    <!--    <transition v-if="isLicense" name="popup">-->
    <!--      <license>-->
    <!--        <template #close>-->
    <!--          <button type="button" class="popup-close" @click="onToggleLicense"><icon-close /></button>-->
    <!--        </template>-->
    <!--      </license>-->
    <!--    </transition>-->
  </main>
</template>

<script>
import { cloneDeep } from 'lodash'
import observer from '@/mixins/observer'
import animation from '@/mixins/animation'

export default {
  components: {
    iconBlank: () => import('@/static/svg/blank.svg'),
    iconDownload: () => import('@/static/svg/download.svg'),
    images: () => import('@/views/fonts/Images'),
    share: () => import('@/components/base/Share'),
    // iconClose: () => import('@/static/svg/close.svg'),
    // license: () => import('@/views/fonts/License')
  },
  mixins: [observer, animation],
  data () {
    return {
      previewText: '',
      selectFontIndex: 0,
      isLicense: false,
      shareImagePath: `${process.env.VUE_APP_CDN_PATH}/static/image/font/m/visual_font.jpg`
    }
  },
  computed: {
    selectFont (val) {
      return val.list[val.selectFontIndex]
    },
    fontList (val) {
      const font = cloneDeep(val.list)
      return font.sort(function (a, b) {
        const c = new Date(val.$moment(a.date, 'YYYY, M'))
        const d = new Date(val.$moment(b.date, 'YYYY, M'))
        return d - c
      })
    },
    list () {
      return [
        {
          family: 'BM HANNA Pro',
          name: this.$t('hannaPro.name'),
          shortName: this.$t('hannaPro.shortName'),
          date: this.$t('hannaPro.date'),
          description: this.$t('hannaPro.content'),
          download: {
            otf: require('@/static/font/BMHANNAPro/BMHANNAProOTF.otf'),
            ttf: require('@/static/font/BMHANNAPro/BMHANNAPro.ttf')
          },
          images: [
            require('@/static/image/font/pc/bmhannapro.gif'),
          ]
        },
        {
          family: 'BM HANNA Air',
          name: this.$t('hannaAir.name'),
          shortName: this.$t('hannaAir.shortName'),
          date: this.$t('hannaAir.date'),
          description: this.$t('hannaAir.content'),
          download: {
            otf: require('@/static/font/BMHANNAAir/BMHANNAAir_otf.otf'),
            ttf: require('@/static/font/BMHANNAAir/BMHANNAAir_ttf.ttf')
          },
          images: [
            require('@/static/image/font/pc/bmhannaair-1@3x.jpg'),
            require('@/static/image/font/pc/bmhannaair-2@3x.jpg'),
            require('@/static/image/font/pc/bmhannaair-3@3x.jpg'),
            require('@/static/image/font/pc/bmhannaair-4@3x.jpg'),
            require('@/static/image/font/pc/bmhannaair-5@3x.jpg'),
            require('@/static/image/font/pc/bmhannaair-6@3x.jpg'),
          ]
        },
        {
          family: 'BM HANNA 11yrs old',
          name: this.$t('hanna11YrsOld.name'),
          shortName: this.$t('hanna11YrsOld.shortName'),
          date: this.$t('hanna11YrsOld.date'),
          description: this.$t('hanna11YrsOld.content'),
          download: {
            otf: require('@/static/font/BMHANNA_11yrs/BMHANNA_11yrs_otf.otf'),
            ttf: require('@/static/font/BMHANNA_11yrs/BMHANNA_11yrs_ttf.ttf')
          },
          images: [
            require('@/static/image/font/pc/bmhanna11yrs-1@3x.jpg'),
            require('@/static/image/font/pc/bmhanna11yrs-2@3x.jpg'),
            require('@/static/image/font/pc/bmhanna11yrs-3@3x.jpg'),
            require('@/static/image/font/pc/bmhanna11yrs-4@3x.jpg'),
            require('@/static/image/font/pc/bmhanna11yrs-5@3x.jpg'),
            require('@/static/image/font/pc/bmhanna11yrs-6@3x.jpg'),
          ]
        },
        {
          family: 'BM Euljiro oraeorae',
          name: this.$t('euljiroOraeorae.name'),
          shortName: this.$t('euljiroOraeorae.shortName'),
          date: this.$t('euljiroOraeorae.date'),
          description: this.$t('euljiroOraeorae.content'),
          download: {
            otf: require('@/static/font/BMEuljirooraeorae/BMEuljirooraeoraeOTF.otf'),
            ttf: require('@/static/font/BMEuljirooraeorae/BMEuljirooraeorae.ttf')
          },
          images: [
            require('@/static/image/font/pc/bmeuljirooraeorae-1.gif'),
            require('@/static/image/font/pc/bmeuljirooraeorae-2@3x.jpg'),
            require('@/static/image/font/pc/bmeuljirooraeorae-3@3x.jpg'),
            require('@/static/image/font/pc/bmeuljirooraeorae-4@3x.jpg'),
          ]
        },
        {
          family: 'BM Euljiro 10 years later',
          name: this.$t('euljiro10YearsLater.name'),
          shortName: this.$t('euljiro10YearsLater.shortName'),
          date: this.$t('euljiro10YearsLater.date'),
          description: this.$t('euljiro10YearsLater.content'),
          download: {
            otf: require('@/static/font/BMEuljiro10yearslater/BMEuljiro10yearslaterOTF.otf'),
            ttf: require('@/static/font/BMEuljiro10yearslater/BMEuljiro10yearslater.ttf')
          },
          images: [
            require('@/static/image/font/pc/bmeuljiro10yearslater-1@3x.jpg'),
            require('@/static/image/font/pc/bmeuljiro10yearslater-2@3x.jpg'),
            require('@/static/image/font/pc/bmeuljiro10yearslater-3@3x.jpg'),
            require('@/static/image/font/pc/bmeuljiro10yearslater-4@3x.jpg'),
          ]
        },
        {
          family: 'BM EULJIRO',
          name: this.$t('euljiro.name'),
          shortName: this.$t('euljiro.shortName'),
          date: this.$t('euljiro.date'),
          description: this.$t('euljiro.content'),
          download: {
            otf: require('@/static/font/BMEULJIRO/BMEULJIRO.otf'),
            ttf: require('@/static/font/BMEULJIRO/BMEULJIROTTF.ttf')
          },
          images: [
            require('@/static/image/font/pc/bmeuljiro-1@3x.jpg'),
            require('@/static/image/font/pc/bmeuljiro-2@3x.jpg'),
            require('@/static/image/font/pc/bmeuljiro-3@3x.jpg'),
            require('@/static/image/font/pc/bmeuljiro-4@3x.jpg'),
            require('@/static/image/font/pc/bmeuljiro-5@3x.jpg'),
            require('@/static/image/font/pc/bmeuljiro-6@3x.jpg'),
          ]
        },
        {
          family: 'BM KIRANGHAERANG',
          name: this.$t('kiranghaerang.name'),
          shortName: this.$t('kiranghaerang.shortName'),
          date: this.$t('kiranghaerang.date'),
          description: this.$t('kiranghaerang.content'),
          download: {
            otf: require('@/static/font/BMKIRANGHAERANG/BMKIRANGHAERANG-OTF.otf'),
            ttf: require('@/static/font/BMKIRANGHAERANG/BMKIRANGHAERANG-TTF.ttf')
          },
          images: [
            require('@/static/image/font/pc/bmkiranghaerang-1@3x.jpg'),
            require('@/static/image/font/pc/bmkiranghaerang-2@3x.jpg'),
            require('@/static/image/font/pc/bmkiranghaerang-3@3x.jpg'),
            require('@/static/image/font/pc/bmkiranghaerang-4@3x.jpg'),
            require('@/static/image/font/pc/bmkiranghaerang-5@3x.jpg'),
            require('@/static/image/font/pc/bmkiranghaerang-6@3x.jpg'),
          ]
        },
        {
          family: 'BM YEONSUNG',
          name: this.$t('yeonsung.name'),
          shortName: this.$t('yeonsung.shortName'),
          date: this.$t('yeonsung.date'),
          description: this.$t('yeonsung.content'),
          download: {
            otf: require('@/static/font/BMYEONSUNG/BMYEONSUNG_otf.otf'),
            ttf: require('@/static/font/BMYEONSUNG/BMYEONSUNG_ttf.ttf')
          },
          images: [
            require('@/static/image/font/pc/bmyeonsung-1@3x.jpg'),
            require('@/static/image/font/pc/bmyeonsung-2@3x.jpg'),
            require('@/static/image/font/pc/bmyeonsung-3@3x.jpg'),
            require('@/static/image/font/pc/bmyeonsung-4@3x.jpg'),
            require('@/static/image/font/pc/bmyeonsung-5@3x.jpg'),
          ]
        },
        {
          family: 'BM DoHyeon',
          name: this.$t('dohyeon.name'),
          shortName: this.$t('dohyeon.shortName'),
          date: this.$t('dohyeon.date'),
          description: this.$t('dohyeon.content'),
          download: {
            otf: require('@/static/font/BMDOHYEON/BMDOHYEON_otf.otf'),
            ttf: require('@/static/font/BMDOHYEON/BMDOHYEON_ttf.ttf')
          },
          images: [
            require('@/static/image/font/pc/bmdohyeon-2@3x.jpg'),
            require('@/static/image/font/pc/bmdohyeon-3@3x.jpg'),
            require('@/static/image/font/pc/bmdohyeon-4@3x.jpg'),
            require('@/static/image/font/pc/bmdohyeon-5@3x.jpg'),
            require('@/static/image/font/pc/bmdohyeon-6@3x.jpg'),
          ]
        },
        {
          family: 'BM JUA',
          name: this.$t('jua.name'),
          shortName: this.$t('jua.shortName'),
          date: this.$t('jua.date'),
          description: this.$t('jua.content'),
          download: {
            otf: require('@/static/font/BMJUA/BMJUA_otf.otf'),
            ttf: require('@/static/font/BMJUA/BMJUA_ttf.ttf')
          },
          images: [
            require('@/static/image/font/pc/bmjua-1@3x.jpg'),
            require('@/static/image/font/pc/bmjua-2@3x.jpg'),
            require('@/static/image/font/pc/bmjua-3@3x.jpg'),
            require('@/static/image/font/pc/bmjua-4@3x.jpg'),
            require('@/static/image/font/pc/bmjua-5@3x.jpg'),
          ]
        },
        {
          family: 'BM HANNA',
          name: this.$t('hanna.name'),
          // shortName: this.$t('hanna.shortName'),
          date: this.$t('hanna.date'),
          description: this.$t('hanna.content'),
          // download: {
          //   otf: require('@/static/font/BMHANNA_11yrs/BMHANNA_11yrs_otf.otf'),
          //   ttf: require('@/static/font/BMHANNA_11yrs/BMHANNA_11yrs_ttf.ttf')
          // },
          images: [
            require('@/static/image/font/pc/bmhanna-1@3x.jpg'),
          ]
        }
      ]
    }
  },
  methods: {
    onPreviewText (e) {
      this.previewText = e.target.innerText
    },
    onToggleLicense () {
      this.isLicense = !this.isLicense
    }
  }
}
</script>
